import React, { createContext, useContext, useRef, useState } from 'react';
import { roomAttachmentTypeIds } from '../../../../../../shared/configs/attachments';

const StateContext = createContext();
const ActionContext = createContext();

export const useUnilateralAttachmentsState = () => useContext(StateContext);
export const useUnilateralAttachmentsAction = () => useContext(ActionContext);

export const UnilateralAttachmentsProvider = ({ children }) => {
  const [value, setValue] = useState(() => new Map());

  const valueRef = useRef(value);
  valueRef.current = value;

  const actions = useState(() => createActions(setValue, valueRef))[0];

  return (
    <StateContext.Provider value={value}>
      <ActionContext.Provider value={actions}>
        {children}
      </ActionContext.Provider>
    </StateContext.Provider>
  );
};

function createActions(setValue, valueRef) {
  return {
    set: (attachments) => {
      setValue((prev) => {
        if (prev.size === 0 && attachments.length === 0) {
          return prev;
        }

        const result = new Map();

        attachments.forEach((attachment) => {
          const { acceptanceClientId: recordId, type } = attachment;

          if (recordId && type.id === roomAttachmentTypeIds.unilateral) {
            let size = result.get(recordId) ?? 0;
            size++;
            result.set(recordId, size);
          }
        });

        if (prev.size === 0 && result.size === 0) {
          return prev;
        }

        return result;
      });
    },

    getAttachmentSizeByRecord: (recordId) =>
      valueRef.current.get(recordId) ?? 0,
  };
}
